export const RQ_GET_RCPA_REPORTS_API = {
  url:'visitrcpa/rcpa_report/<%= divisionId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>?entityTagId=<%= entityTagId %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_MIRROR_RCPA_SELECT = {
  url: 'reports/web/new-effort/mirror-hq-rcpa/<%= divisionId %>/<%= fromDate %>/<%= toDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_MIRROR_HOSPITAL_RCPA_SELECT = {
  url: 'visitrcpa/mirror-hospital-rcpa-report/<%= divisionId %>/<%= fromDate %>/<%= toDate %>',
  method: 'GET',
  auth: true,
};
